export const ADD_CART_PRODUCT = "CART/ADD_PRODUCT"

export const ADD_FAVORITE_PRODUCT = "FAVORITE/ADD_PRODUCT"

export const ADD_BREADCRUMB_ROUTE = "BREADCRUMB/ADD"

export const DELETE_ONE_CART_PRODUCT = "CART/DELETE_ONE_PRODUCT"

export const DELETE_CART_PRODUCT = "CART/DELETE_PRODUCT"

export const DELETE_FAVORITE_PRODUCT = "FAVORITE/DELETE_PRODUCT"

export const DELETE_BREADCRUMB_ROUTE = "BREADCRUMB/DELETE"
